class Router {

	/**
	 * Create a new Router
	 *
	 * @param {Object} routes
	 * @param {String} currentRoute
	 * @param {String} routePath
	 */
	constructor (currentRoute, routePath, appAutoload, frameworkAutoload, routeFunctions, currentRouteName) {
		this.currentRoute = currentRoute;
		this.routePath = routePath;
		this.appAutoload = appAutoload;
		this.frameworkAutoload = frameworkAutoload;
		this.routeFunctions = routeFunctions;
		this.currentRouteName = currentRouteName;
		this.routerType = 'build';

		this.init();
	}

	init() {
		this.appAutoload.init();
		this.frameworkAutoload.init();
		this.routeFunctions = this.lowercaseKeys(this.routeFunctions);
		this.currentRouteName = this.currentRouteName.toLowerCase();
		if (typeof this.routeFunctions[this.currentRouteName] !== 'undefined' && typeof this.routeFunctions[this.currentRouteName].init == 'function') {
			this.routeFunctions[this.currentRouteName].init();
		}

		this.appAutoload.finalize();
		this.frameworkAutoload.finalize();
	}

	lowercaseKeys(obj) {
		return Object.entries(obj).reduce((acc, [key, value]) => {
			acc[key.toLowerCase()] = value;
			return acc;
		}, {});
	}
}

export default Router;
